import { render, staticRenderFns } from "./EternityChallengesTab.vue?vue&type=template&id=6945449d&scoped=true&"
import script from "./EternityChallengesTab.vue?vue&type=script&lang=js&"
export * from "./EternityChallengesTab.vue?vue&type=script&lang=js&"
import style0 from "./EternityChallengesTab.vue?vue&type=style&index=0&id=6945449d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945449d",
  null
  
)

export default component.exports